import { motion } from "framer-motion";
import profileImg from "../assets/profile.jpg";
import { FaLinkedin, FaGithub } from "react-icons/fa";
import VisitorCounter from "./VisitorCounter"; // ✅ Add counter component

export default function Sidebar({ activeSection, scrollToSection, isMobile = false, onCloseMobileMenu }) {
  const sections = [
    "about",
    "experience",
    "education",
    "skills",
    "certifications",
    "projects",
  ];

  return (
    <motion.aside
      initial={{ y: -50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.3 }}
      className={`${
        isMobile
          ? "w-full bg-blue-800 z-50"
          : "md:w-64 h-screen sticky top-0 bg-blue-800"
      } text-white px-6 py-10 flex flex-col items-center justify-center border-none shadow-none outline-none`}
    >
      <div className="text-center space-y-6">
        {/* Profile Picture */}
        <img
          src={profileImg}
          alt="Profile"
          className="w-28 h-28 object-cover rounded-full mx-auto border-4 border-white shadow"
        />

        {/* Name and Email */}
        <div>
          <h1 className="text-3xl font-extrabold leading-tight mb-1">STIVENS</h1>
          <h1 className="text-2xl font-bold leading-tight mb-2">MEJIA-CORNELIO</h1>
          <p className="text-lg text-white">stivensmejia@outlook.com</p>
        </div>

        {/* Navigation Links */}
        <nav className="flex flex-col items-center text-center gap-2 text-lg font-semibold uppercase tracking-wide leading-snug pt-4">
          {sections.map((section) => (
            <button
              key={section}
              onClick={() => {
                scrollToSection(section);
                if (isMobile && typeof onCloseMobileMenu === "function") {
                  setTimeout(() => onCloseMobileMenu(), 300);
                }
              }}
              className={`transition-transform transform hover:scale-110 focus:outline-none duration-200 ${
                activeSection === section
                  ? "text-white font-bold"
                  : "text-blue-200 hover:text-white"
              }`}
            >
              {section.charAt(0).toUpperCase() + section.slice(1)}
            </button>
          ))}
        </nav>

        {/* Social Icons */}
        <div className="flex flex-col items-center gap-4 pt-4">
          <div className="flex justify-center gap-6">
            <a
              href="https://www.linkedin.com/in/stivensmejia-cornelio/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-blue-300"
            >
              <FaLinkedin size={24} />
            </a>
            <a
              href="https://github.com/StubbyHub"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-blue-300"
            >
              <FaGithub size={24} />
            </a>
          </div>

          {/* Visitor Counter */}
          <VisitorCounter />
        </div>
      </div>
    </motion.aside>
  );
}
